interface ClipPathTitleProps {
  title: string;
  color: string;
  bg: string;
  className?: string;
  borderColor: string;
}

const ClipPathTitle = ({ title, color, bg, className, borderColor }: ClipPathTitleProps) => {
  return (
    <div className="general-title">
      <div
        style={{
          clipPath: "polygon(50% 0, 50% 0, 50% 100%, 50% 100%)",
          borderColor: borderColor,
        }}
        className={`${className} border-[.5vw] text-nowrap opacity-0 inline-flex w-fit`}
      >
        <div
          className="md:px-6 px-5 md:py-3 py-2 inline-flex w-fit"
          style={{
            backgroundColor: bg,
          }}
        >
          <h2
            className="font-sans text-[8vw] md:text-[64.936px] font-bold uppercase leading-[1.1] tracking-tight"
            style={{
              color: color,
            }}
          >
            {title}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default ClipPathTitle;
